import { render, staticRenderFns } from "./TextControl.vue?vue&type=template&id=fe2bcd86&scoped=true&"
import script from "./TextControl.vue?vue&type=script&lang=js&"
export * from "./TextControl.vue?vue&type=script&lang=js&"
import style0 from "./TextControl.vue?vue&type=style&index=0&id=fe2bcd86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe2bcd86",
  null
  
)

export default component.exports